import React, { useMemo } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { formatDate } from '../utils/utils';

interface StaleDataAlertProps {
  isStale: boolean | undefined;
  lastDataDate?: string | Date | null;
}

const StaleDataAlert: React.FC<StaleDataAlertProps> = ({ isStale, lastDataDate }) => {
  if (!isStale) return null;

  const dateStr = lastDataDate ? formatDate(lastDataDate) : "Unknown";

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning">
        <AlertTitle>Database Sync Required</AlertTitle>
        Latest stock history is from <strong>{dateStr}</strong>. Indicators and signals may be inaccurate. Please <strong>Sync Stocks</strong> to fetch the latest candles.
      </Alert>
    </Box>
  );
};

export default StaleDataAlert;
